import { getStorage, setStorage } from "@/lib/webStorage";

export const selectDefaultMenuIndex = () => {
  const defaultIndex = getStorage('currentMenuIndex');
  if (defaultIndex) {
    return defaultIndex;
  } else {
    const index = '0';
    setStorage('currentMenuIndex', index);
    return index;
  }
};